import React from 'react';
import AboutGeneral from './views/general.c';
import {SSRDataContext} from '../../../../helpers/SSRDataContext';

export default function AboutGeneralWithSSR(props) {
    return (
        <SSRDataContext.Consumer>
            {ssrData => <AboutGeneral {...props} ssrData={ssrData} />}
        </SSRDataContext.Consumer>
    );
}
